import { initAddToCmapOption } from '../../AddTo/AddToCmap/helpers/initAddToCmapOption'
import { initAddToTrackerOption } from '../../AddTo/AddToTracker/helpers/initAddToTrackerOption'

export const initAddToOptions = () => {
  initAddToCmapOption()
  initAddToTrackerOption()
}
